
import { Base } from '../base-component';

import Slider from '../slider/slider.component';
import { TooltipsService } from '../../services/tooltips.service';

import './product-offering-slider.component.scss';

import * as $ from 'jquery';
import * as _ from 'lodash';

export class ProductOfferingSlider extends Base {

	endpoint: string;
	filterJson: any;
	productJson: any;
    comparison:any;
    comparable: boolean;
	productContainer: JQuery<HTMLElement>;
	compareCard: JQuery<HTMLElement>;
	removeAll: JQuery<HTMLElement>;
	filterItem: JQuery<HTMLElement>;
	producttype: string;

	sliderContainer: Element;
	sliderPagination: Element;
	sliderConfig: SwiperOptions;
	sliderNext: Element;
	sliderPrev: Element;


	constructor(element: Element){
		
		super(element);
				
	}
		
	init(){		
		this.productContainer = $('.product-card-wrapper');
		this.endpoint = this.element.getAttribute('data-endpoint');
		
		this.producttype = $("div.component.product-offering-slider").attr('data-producttype');
		if(this.producttype) {
			this.producttype = this.producttype.toLowerCase();
		}

		this.getProducts();

	}
		
	bindEvents() {

		window.addEventListener('resize', this.debounce(() => {
			
			this.normalizeCardHeight();
				
		}, 50, false));

	}

	animate() {
		
	}

	getProducts() {

			
		let parseData = sliderJsonData;

		this.filterJson = parseData.filters;
		this.productJson = parseData.products;
		
		this.comparable = _.some(this.productJson, (product) => {
			return product.comparable;
		});

		let docfragment = document.createDocumentFragment();

		this.productJson.forEach(card => {
			
			docfragment.appendChild(this.renderProduct(card));

		});

		this.productContainer[0].appendChild(docfragment);

		TooltipsService.initTooltips();

		this.sliderContainer = this.element.querySelector('.swiper-container');
		this.sliderPagination = this.element.querySelector('.swiper-pagination');
		this.sliderNext = this.element.querySelector('.swiper-button-next');
		this.sliderPrev = this.element.querySelector('.swiper-button-prev');

		setTimeout(()=> {

			this.initSlider();                
			this.normalizeCardHeight();
			
		}, 500);

	}

	initSlider() {

		this.sliderConfig = {
			slidesPerView: 2,
			spaceBetween: 35,
			initialSlide: 0,
			breakpoints: {
				1200: {
					initialSlide: 0,
					slidesPerView: 1.8,
					spaceBetween: 35,
				},
				768: {
					initialSlide: 0,
					slidesPerView: 1.5,
					spaceBetween: 20,
				},
				576: {
					initialSlide: 0,
					slidesPerView: 1.2,
					spaceBetween: 15,
				}
			},
			pagination: {
				el: this.sliderPagination,
				type: 'bullets',
				clickable: true
			},
			navigation: {
				nextEl: this.sliderNext,
				prevEl: this.sliderPrev,
			}
		};

		Slider.init(this.sliderContainer, this.sliderConfig);
	}

	normalizeCardHeight() {

		if ($(window).width() < 951) {	

			$('.product-card__content').css('min-height', `initial`);
			$('.product-card__content > p').css('min-height', `initial`);

		} else {

			let highestContent = 0;
			$('.product-card__content').each((index, el) => {

				let contentHeight = $(el).outerHeight();

				if (highestContent < contentHeight) {
					highestContent = contentHeight;
				}

			});

			$('.product-card__content').css('min-height', `${highestContent}px`);

			let highestParagragh = 0;
			$('.product-card__content > p').each((index, el) => {

				let paragraphHeight = $(el).height();

				if (highestParagragh < paragraphHeight) {
					highestParagragh = paragraphHeight;
				}

			});

			$('.product-card__content > p').css('min-height', `${highestParagragh}px`);
            
            let highestTerms = 0;
			$('.product-card__terms').each((index, el) => {

				let termHeight = $(el).height();

				if (highestTerms < termHeight) {
					highestTerms = termHeight;
				}

            });

			$('.product-card__terms').css('min-height', `${highestTerms}px`);

		}

	}

	renderProduct(input: any) {

		let productPrices = "";
        let productTags = "";
        let productButtons = "";
        let productTerms = "";

        let termCount = 0;

		input.pricing.forEach(price => {

            if(price.terms){
				termCount++;

				let asterix = '';
				for (let index = 0; index < termCount; index++) {
					asterix += '*';
				}

				productTerms += `
					<div>
						<span class="title title--asterisk">${asterix}</span>
						<span>${price.terms}</span>
					</div>
				`;
			}

			productPrices += this.renderProductPrice(price, termCount);
		});

		input.tags.forEach(tag => {
			productTags += " " + tag.replace(/ /g, "-");
        });
        
        let btnCount = 0;

        input.buttons.forEach(btn => {
            
            productButtons += this.renderButtons(btn, btnCount, input);

            btnCount++;
        });

        productTerms = `
			<div class="product-card__terms">

				${productTerms}

			</div>`;		
			
		let output = "";
		output += `<div class="product-card product-card__image swiper-slide ${productTags.toLowerCase()}" data-id="${input.id}">`;

		switch(input.title.toLowerCase()) { 
			case "apply for a new student loan": { 
				output += '<div class="feature-badge">Increase Limit</div>';
				if (input.cardImage) {
					output += `<img class="product-card__image--card" src="${input.cardImage}">`;
				}
			   break; 
			}
			default: { 
				if (input.onPromotion) {
					output += `<div class="feature-badge">
						${input.promotionLabel}
					</div>`;
				}
				if (input.cardImage) {
					output += `<img class="product-card__image--card" src="${input.cardImage}">`;
				}
			   break; 
			} 
		}
		
		output += `
		<div class="product-card__outer">
			<div class="product-card__inner" data-trackingregion="product offering `+this.producttype+` > ${input.title.toLowerCase()}">
				<div class="product-card__content">        
				
					<div class="product-card__title title title--module-sub-title">
						${input.title}
					</div>

					<div class="title-gradient title-gradient--product"></div>
					
					<p>${input.subTitle}</p>

					<div class="row">
						${productPrices}
					</div>				

				</div>`;

		//card buttons
		output += `
			<div class="product-card__buttons">		
		
				<div class="row">		
		
					<div class="col-12">
                    
					${productTerms}
					
					<div class="float-md-right float-sm-left">					
		
		`;

		output +=`
                            <div class="${this.comparable ? 'product-card__compare-placeholder': 'product-card__compare-placeholder product-card__compare-placeholder--sml' }"></div>
						</div>

					</div>

					${productButtons}

				</div>

			</div>`;
		
		//end card buttons
		
		output += `</div>`; //inner close
		output += `</div>`; //outer close
		output += `</div>`; //main close

		return document.createRange().createContextualFragment(output);
	}

    renderButtons(input, index, product) {

		let output = "";

		// Analytics - included the product in the param lis so we can get the prod name

		let productTitle = product.title ? product.title : "<<product name>>";

        if (input.isModal) {

            output += `
            <div class="${index === 0 ? 'product-card__button-wrap' : ''} col-xs-6 col-sm-6">
                <a class="button button--main js-apply-now-modal-open"
					href="#"
					target=""
					data-modal="apply-now-modal-${input.modalId}"
					data-id="link_content_product offering"
					data-text="`+this.producttype+` | `+productTitle+` | ${input.title} button click">

                    ${input.title}

                </a>
            </div>
            `;

        } else {

            output += `
                <div class="${index === 0 ? 'product-card__button-wrap' : ''} col-xs-6 col-sm-6">
                    <a class="button button--main ${index === 0 ? '' : 'button--white button--border-blue'}"
						href="${input.url}"
						target="${input.target}"
						data-id="link_content_product offering"
						data-text="`+this.producttype+` | `+productTitle+` | ${input.title} button click">

                        ${input.title}

                    </a>
                </div>
            `;

        }

        return output;
		
    }

	renderProductPrice(input, termCount?:number) {
		let output = "";

		output += `<div class="product-card__price col-6 col-xs-6 col-sm-6">`;

		if (input.symbol && input.symbol.toLowerCase() == 'r') {
			output += `
				<span class="title title--initial title--currency">
					${input.symbol}
				</span>
			`;
		}

		if (input.note) {

			output += `
				<span class="title title--initial product-card__price__note">
					${input.title}
				</span>
			`;

		}else{

			output += `
				<span class="title title--initial title--number">
					${input.title}	
				</span>		
			`;

		}

		// output += `
		// 	<span class="title title--initial title--number">
		// 		${input.title}
		// 	</span>
		// `;

		if (input.symbol && input.symbol.toLowerCase() != 'r') {
			output += `
				<span class="title title--initial title--currency">
					${input.symbol}
				</span>
			`;
		}

		if (input.tooltip) {
			output += `
				<span title="${input.tooltip}" data-title="${input.tooltip}">
					<i data-component="icon" data-icon="icon-tooltip" class="icon "><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
						<path fill="#0089FF" fill-rule="evenodd" d="M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm-1-3h2v-2H7v2zm0-4.004h2V3H7v5.996z"></path>
					</svg>
					</i>
				</span>
			`;
		}



        if (input.terms) {

			let asterix = '';
			for (let index = 0; index < termCount; index++) {
				asterix += '*';
			}

			output += `
				<span class="title title--initial title--asterisk">${asterix}</span>
			`;
		}

		if (input.strike) {
			output += `
				<div class="title title--initial title--number-strike">
					<span class="title title--number-striker"></span>
			`;

			if (input.symbol) {
				output += `
					<span class="title title--initial title--currency-sml">
						${input.symbol}
					</span>
				`;
			}
			
			output += `
					<span class="title title--initial title--number-sml">
						${input.strike}
					</span>
				</div>
			`;
		}

		output += `
			<div class="title title--notes">
				${input.subTitle}
			</div>	
		`;
		
		output += `</div>`; //main close

		return output;
	}
	
	debounce(func, wait, immediate) {
		let timeout;
		return function() {
			let context = this, args = arguments;
			let later = function() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			let callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};

}



// WEBPACK FOOTER //
// ./components/product-offering-slider/product-offering-slider.component.ts